import { useEffect } from 'react';
import { motion, AnimatePresence, useAnimation } from 'framer-motion';

export const wordVariants = {
  before: { transition: { staggerChildren: 0.08 } },
  after: { transition: { staggerChildren: 0.016 } },
};

export const letterVariants = {
  before: {
    y: '100%',
    transition: {
      type: 'spring',
      damping: 20,
      stiffness: 50,
      duration: 0.4,
    },
  },
  after: {
    y: '0%',
    transition: {
      type: 'spring',
      // damping: 20,
      // stiffness: 50,
      bounce: 0,
      duration: 0.4,
    },
  },
};

export const AnimatedText = ({ isVisible, children }) => {
  const textAnimation = useAnimation();

  useEffect(() => {
    if (isVisible) {
      // play animation
      textAnimation.start('after');
      return () => textAnimation.start('before');
    }
  }, [isVisible]);

  return (
    <AnimatePresence>
      <motion.span
        className="animated-text"
        key={children}
        variants={wordVariants}
        initial="before"
        animate={textAnimation}
        exit="before"
        style={{ display: 'inline', paddingTop: '0.15em' }}
      >
        {children.split(' ').map((word, wordI) =>
          word === '_' ? (
            <br key={`_${wordI}`} />
          ) : (
            <div
              key={`word-${word}-${wordI}`}
              style={{
                display: 'inline-block',
                overflow: 'hidden',
                height: '0.85em',
                marginBottom: '0.15em',
                marginTop: '-0.15em',
              }}
            >
              {Array.from(word).map((letter, index) => (
                <motion.span
                  key={`${index}-${letter}`}
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    width: 'auto',
                  }} // Position elements
                  variants={letterVariants}
                >
                  {letter === ' ' ? '\u00A0' : letter}
                </motion.span>
              ))}
              {'\u00A0'}
            </div>
          )
        )}
      </motion.span>
    </AnimatePresence>
  );
};
